<!-- Normal Icon -->
<span *ngIf="!iconButton"
      [id]="id || ''"
      [ngClass]="classAttrValue"
      [ngStyle]="styleAttrValue"
      [attr.title]="title"
      [attr.aria-hidden]="!ariaVisible">
</span>
<!-- Icon Button -->
<button *ngIf="iconButton"
    [id]="id || ''"
    [ngClass]="classAttrValue"
    [ngStyle]="styleAttrValue"
    [title]="title"
    [attr.aria-label]="ariaLabel"
    [attr.aria-hidden]="!ariaVisible"
    [attr.data-area]="dataArea"
    [attr.data-nav]="dataNav"
    (click)="handleClick()"
    [ohpFocusOnLoad]="focusOnLoad"
    keyboardFocusTooltip>
</button>
